import React from "react";
import { observer } from "mobx-react";

import BettingTipsCard from "./BettingTipsCard";
import { BettingTips } from "@api-types/bet-booster/BettingTipsType";

export default observer(function BettingTipsListItem(props: {
	data: BettingTips;
	index: number;
	activatePopup: (id: string, index: number) => void;
}) {
	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		props.activatePopup(props.data.id, props.index + 1);
	};

	return (
		<div className="carousel__item carousel--most__item">
			<div
				onClick={handleClick}
				className="carousel__slide carousel--most__slide"
			>
				<div className="card card--qp card--qp--nowrap card--bbt card--bbt--nowrap card--bbt--slide">
					<BettingTipsCard data={props.data} />
				</div>
			</div>
		</div>
	);
});
